import { useEffect } from "react";
import { useNavigate } from "react-router-dom-v5-compat";
import { ROUTES } from "routing/routes";

import {
  Box,
  Center,
  Heading,
  Stack,
  useBackgroundColor
} from "@seneca/senekit";

import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

export default function DiagnosisPage() {
  const navigate = useNavigate();

  const { noUpdateRedirect } = useTypedState(ROUTES.DIAGNOSIS);

  useEffect(() => {
    if (!noUpdateRedirect) {
      navigate(ROUTES.UPDATE.buildPath({}), {
        state: {
          redirectState: {
            noUpdateRedirect: true
          },
          redirectPostUpdate: ROUTES.DIAGNOSIS.path
        }
      });
    }
  }, [navigate, noUpdateRedirect]);

  const background = useBackgroundColor();

  return (
    <Box height="100vh" background={background}>
      <Center>
        <Stack align="center" space="xlarge">
          <Heading level={"3"}>Coming soon...</Heading>
        </Stack>
      </Center>
    </Box>
  );
}
